<template>
    <activix-popover placement="top" v-if="showWidget">
        <template #trigger>
            <div class="flex text-sm text-gray-800 | transition cursor-pointer hover:text-gray-600">
                <icon name="regular/email-action-reply" />
            </div>
        </template>

        <div class="flex flex-col max-w-xs p-3 space-y-1.5 rounded-lg overflow-hidden">
            <div class="flex justify-between gap-2 items-center">
                <span class="font-semibold" v-text="parentNoteOwnerName" />
                <span class="text-sm text-gray-600" v-text="parentNoteDateTime" />
            </div>

            <p class="mb-0 line-clamp-2 text-sm">
                <mention-text :content="note.parent.content" />
            </p>
        </div>
    </activix-popover>
</template>

<script>
    import { ActivixPopover } from '@/components/activix-ui/index.ts';
    import MentionText from '@/components/MentionText/MentionText.vue';

    import Comment from '@/entities/Comment.ts';
    import ActivixDate from '@/value-objects/ActivixDate.js';

    export default {
        components: { ActivixPopover, MentionText },

        props: {
            depth: {
                type: Number,
                required: true,
            },
            note: {
                type: Comment,
                required: true,
            },
        },

        computed: {
            parentNoteDateTime() {
                const createdAt = as_locale(this.note.parent.created_at, 'created_at');

                if (createdAt.isSameDay(now())) {
                    const date = createdAt.fromNow(false, this.$i18n.getLocale());

                    return date[0].toUpperCase() + date.slice(1);
                }

                return this.formatNoteDate(createdAt);
            },

            showWidget() {
                return this.depth >= 1 && this.note.parent.id;
            },

            parentNoteOwnerName() {
                return this.note.parent.user?.fullName;
            },
        },

        methods: {
            formatNoteDate(date) {
                return new ActivixDate(date.toDate()).toHumanShort(false, this.$i18n.getLocale());
            },
        },
    };
</script>
